import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { useSelector, useDispatch } from 'react-redux';
import { updateState, updateInstitution, selectC5State } from "../features/counter/counterSlice";
import { isPWAInstalled } from '../features/search/util';

const LoginModal = (props) => {
  const { instance } = useMsal();
 const dispatch = useDispatch();
 const currentC5State = useSelector(selectC5State);
  const showAccessKey = useSelector((state) => state.counter.showAccessKey);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('login')) { document.body.style.display = 'none'; }
    if (params.get('login') === 'true') { handleLogin(); }

    const datalist = document.getElementById('institutions');
    // console.log(window.tgc);
    // TODO: Restore here or in login... but somewhere.
    Object.keys(window.tgc).map((key) => {
      const option = document.createElement("option");
      const currentValue = atob(window.tgc[key])
      option.title = currentValue;
      option.value = currentValue;
      // datalist.appendChild(option);
    });

  }, []);

  const handleCloseModal = () => {
    let tglogin = document.getElementById('tglogin');
    let modalBackdrop = document.querySelector('.modal-backdrop');

    if (tglogin.classList.contains('in')) {
      tglogin.classList.toggle('in');
      setTimeout(() => {
        tglogin.style.display = 'none';
        if (modalBackdrop === undefined) {
          modalBackdrop.style.display = 'none';
          modalBackdrop.classList.toggle('in');
        }
      }, 100);
    }
  }

  const handleLogin = () => {
    window.history.pushState({}, '', '/');
    instance.loginPopup(loginRequest).catch(e => {
      console.error(e);
    });

  };


  function checkReferalToken() {
    const referralToken = document.getElementById('referralToken').value;
    let decodedToken;
    if (referralToken) {
      try {
        decodedToken = JSON.parse(atob(referralToken));

        if ('exp' in decodedToken && decodedToken.exp < Date.now()) {
          alert('Token expired');
          return;
        }
      } catch (error) {
        alert('Invalid token');
        return;
      }
      localStorage.setItem('tgt', referralToken);
      const expiryDate = new Date(decodedToken.exp).toISOString();
      localStorage.setItem('tg_expirydate', btoa(JSON.stringify(expiryDate)));
      window.dataLayer = window.dataLayer || [];
          
      window.dataLayer.push({
        'event': 'login',
        'institution': decodedToken.name,
        'origin': 'access-key'
      });
      const decodednstitution = {
        name: decodedToken.name,
        id: decodedToken.id,
        orgid: decodedToken.orgid,
      };

      dispatch(updateInstitution(decodednstitution));
      if (decodedToken.tg_shortname) {
                    dispatch(updateState({ 
                      C5State: {
                        ...currentC5State,
                        shortName: decodedToken.tg_shortname
                      }
                    }));
                  }
      alert('Access key set');
      window.location.reload();
    }
  }
  return createPortal(
    <>
      <div id="tglogin" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={handleCloseModal} data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Log In</h4>
            </div>
            <div id="tgloginid" className="modal-body" style={{ maxHeight: '650px', overflowY: 'auto', paddingLeft: '30px', paddingRight: '30px' }}>
               {isPWAInstalled() && showAccessKey && <div className="list-group">
                <div className="jumbotron white-jumbo">
                  <h4 className="list-group-item-heading">
                    <i className="fa fa-info-circle"></i> &nbsp;
                    Access key
                  </h4>
                  <div className="input-group input-group-lg" style={{ marginTop: '10px' }}>
                    <input type="email" className="form-control input-lg" id="referralToken"
                      placeholder="Access key" autoComplete='off' required />
                    <span className="input-group-addon" style={{ cursor: 'pointer' }} onClick={checkReferalToken}>
                      Submit
                    </span>
                  </div>
                  <div id="selectedInstitution"></div>
                </div>
              </div>}
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById('portal')
  )
};



export default LoginModal;
